import formatFileSize from './utils'

const messages = {
  _default: () => `el valor no es válido.`,
  after: (field, [target, inclusion]) =>
    `debe ser después de ${inclusion ? 'o igual a ' : ''}${target}.`,
  alpha_dash: () =>
    `el campo debe contener valores alfanuméricos, así como carácteres especiales.`,
  alpha_num: () =>
    `el campo debe contener solo carácteres alfanuméricos. `,
  alpha_spaces: () =>
    `el campo debe contener solo carácteres alfanuméricos o espacios. `,
  alpha: () => `el campo debe contener solo carácteres alfabéticos. `,
  before: (field, [target, inclusion]) =>
    `debe ser antes de ${inclusion ? 'o igual a ' : ''}${target}.`,
  between: (field, [min, max]) =>
    `el campo debe estar entre ${min} and ${max}.`,
  confirmed: () => `la confirmación no coincide.`,
  credit_card: () => `campo inválido.`,
  date_between: (field, [min, max]) =>
    `debe estar entre ${min} and ${max}.`,
  date_format: (field, [format]) =>
    `debe estar en formato ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `el campo debe ser numérico y contener ${
      !decimals || decimals === '*' ? '' : decimals
    } decimal points.`,
  digits: (field, [length]) =>
    `el campo debe ser numérico y contener exactamente ${length} digits.`,
  dimensions: (field, [width, height]) =>
    `el campo debe ser de ${width} pixels por ${height} pixels.`,
  email: () => `el campo debe ser un email válido.`,
  ext: () => `el campo debe ser un fichero válido.`,
  image: () => `el campo debe ser una imagen.`,
  in: () => `el campo debe ser un valor válido.`,
  integer: () => `el campo debe ser un entero.`,
  ip: () => `el campo debe ser una IP válida.`,
  length: (field, [length, max]) => {
    if (max) {
      return `longitud debe estar entre ${length} y ${max}.`
    }

    return `longitud debe ser ${length}.`
  },
  max: (field, [length]) =>
    `el campo no debe contener mas de ${length} caracteres.`,
  max_value: (field, [max]) => `el campo debe ser ${max} o menor.`,
  mimes: () => `el campo debe ser un tipo de fichero válido.`,
  min: (field, [length]) =>
    `el campo debe ser de almenos ${length} caracteres.`,
  min_value: (field, [min]) => `el campo debe ser ${min} o mayor.`,
  not_in: () => `el campo debe ser un valor válido.`,
  numeric: () => `el campo debe contener sólo valores numéricos.`,
  regex: () => `formato del campo inválido.`,
  required: () => `el campo es obligatorio.`,
  size: (field, [size]) =>
    `el tamaño debe ser menor a ${formatFileSize(size)}.`,
  url: () => `el campo no es una URL válida.`,
  fullName: () => 'no es válido (nombre, primer apellido y máx 120 caracteres)',
  emailInput: () => 'el campo debe ser un email válido.',
  fullNamePerCountry: () => 'no es válido (nombre, primer apellido y máx 18 caracteres)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'es',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/es.js